// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22tHQ","questions":"styles_questions__2iOz4","footer":"styles_footer__1ZOk5"};